module.exports = "<div>\r\n  <router-outlet></router-outlet>\r\n</div>"